"use client";

import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import NextLink from "next/link";
import { useAppContext } from "@/contexts/app-context";

interface AdminEditButtonProps {
    shopId: string;
}

export function AdminEditButton({ shopId }: AdminEditButtonProps) {
    const { isAdmin } = useAppContext();

    if (!isAdmin) return null;

    return (
        <Button variant="ghost" size="icon" asChild>
            <NextLink href={`/admin/shops/${shopId}`}>
                <Pencil className="h-4 w-4" />
            </NextLink>
        </Button>
    );
}
